<style lang="less" scoped>

        .list-querys-div {
            display: flex;
            flex-wrap: wrap;
            .list-query-child-div {
                width: 320px;
                flex-grow: 1;
                margin: 0 16px 12px 0;
                .query-title-div {
                    font-size: 14px;
                    margin-right: 12px;
                    width: 100px;
                    line-height: 32px;
                    text-align: right;
                    color: #8F9BB3;
                }
            }
            .empty-query-child-div {
                width: 320px;
                flex-grow: 1;
                margin: 0 16px 12px 0;
            }
        }
</style>

<template>
    <div class="page-querys flex">
        <div class="list-querys-div flex-1">
            <slot name="inputs"></slot>
            <div class="empty-query-child-div"></div>
            <div class="empty-query-child-div"></div>
            <div class="empty-query-child-div"></div>
            <div class="empty-query-child-div"></div>
        </div>
        <div class="query-btns-div">
            <slot name="actions"></slot>
        </div>
    </div>
</template>

<script>
    export default {
        name:'ZDListQuerys',
        data() {
            return {}
        },
        methods: {
            init() {}
        },
        mounted() {
            this.init();
        }
    }
</script>